module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['single', {
      'is-hidden': _vm.singleIsHidden
    }]
  }, [_c('single-header', {
    attrs: {
      "project": _vm.project
    }
  }, [_c('p', [_vm._v("Be it surfing the web in your favorite browser, buying something on Amazon\n        or simply using your phone to play some games while on the train —\n        data is being collected. This site explains what is happening and how one\n        can prevent it.")])]), _vm._v(" "), _c('single-section', {
    attrs: {
      "info": "",
      "color": _vm.project.color,
      "header": "2nd Place in Digital Media Contest"
    }
  }, [_c('p', [_vm._v("This project reached 2nd place in a digital media contest organized by the\n        parliament of Baden-Württemberg, South Germany in 2017 for educational\n        advertisting about data collection in our everyday lifes.")])]), _vm._v(" "), _c('single-section', [_c('img', {
    attrs: {
      "src": "assets/projects/digital-data-collection/site.jpg",
      "alt": "Screenshot the website"
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Page Transition"
    }
  }, [_c('p', [_vm._v("The routing system which allows for a smooth page transition\n        was designed from scratch since it is a rather simple setup\n        with only five pages. To know which page to show, the scripts crawles the given URL\n        and runs it through a switch. The new data is loaded via the Fetch API.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/digital-data-collection/transition.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcc09b5"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/single/digital-data-collection.vue
// module id = 113
// module chunks = 0